import { render, staticRenderFns } from "./IconSprite.vue?vue&type=template&id=106a9a6b&scoped=true&"
import script from "./IconSprite.vue?vue&type=script&lang=ts&"
export * from "./IconSprite.vue?vue&type=script&lang=ts&"
import style0 from "./IconSprite.vue?vue&type=style&index=0&id=106a9a6b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106a9a6b",
  null
  
)

export default component.exports